// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.image[data-v-73dd602c] {\r\n  width: 239px;\r\n  height: 480px !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
